import React from 'react'
import './Enter_Payout_Modal.css'
import { Form, Modal } from 'react-bootstrap'
import RedRoundBtn from '../../Common_Btn/RedRoundBtn/RedRoundBtn'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useForm } from 'react-hook-form'

const Enter_Payout_Modal = (props) => {

    const {register} = useForm();

    return (
        <section className='Enter_Payout_Modal'>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="Filter_Sort_By_Modal common_modal"
            >
                <Modal.Header>
                    <Modal.Title>Enter Desired Payout</Modal.Title>
                    <div className='close_icon_holder' onClick={() => { props?.onHide() }}>
                        <FontAwesomeIcon icon={faXmark} className='close_icon' />
                    </div>
                </Modal.Header>

                <Modal.Body>

                    <div className='enter_amount_form'>
                        <Form className='tl_insurance_form edit_p_form'>
                            <Form.Group className="blue_label_group">
                                <Form.Label>Enter Desired Payout</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    placeholder="Enter Amount"
                                    {...register("name", {
                                        required: "Name is required",
                                    })}
                                />
                            </Form.Group>

                            <div className='btn_holder'>
                                <RedRoundBtn btn_name="Submit"
                                />
                            </div>
                        </Form>

                    </div>

                </Modal.Body>
            </Modal>
        </section>
    )
}

export default Enter_Payout_Modal
